import Vue from 'vue'
import Router from 'vue-router'

import AboutUs from '@/views/about-us'
import PriceTable from '@/views/pricetable'
import BusinessProfile from '@/views/business-profile'
import ContactUs from '@/views/contact-us'
import Contacts from '@/views/contacts'
import Dashboard from '@/views/dashboard'
import ForgotPassword from '@/views/forgot-password'
import HelpCenter from '@/views/help-center'
import Marketing from '@/views/marketing'
import Merchant from '@/views/merchant'
import Merchants from '@/views/merchants'
import MerchantsList from '@/views/merchants-list'
import MerchantOffer from '@/views/merchant-offer'
import NewProfile from '@/views/new-profile'
import NotFound from '@/views/not-found'

import PerNotifications from '@/views/per-notifications'
import BizNotifications from '@/views/biz-notifications'
import RefNotifications from '@/views/ref-notifications'

import Orders from '@/views/orders'
import OrdersWeekly from '@/views/orders-weekly'
import Onboarding from '@/views/onboarding'
import Privacy from '@/views/privacy'
import Profile from '@/views/profile'
import Purse from '@/views/purse'
import QrReferral from '@/views/qr-referral'
import Schedule from '@/views/schedule'
import Settings from '@/views/settings'
import Account from '@/views/account'
import SignIn from '@/views/sign-in'
import SignUp from '@/views/sign-up'
import SignUpCustomer from '@/views/sign-up-customer'
import SignUpRef from '@/views/sign-up-ref'
import SignUpLink from '@/views/sign-up-link'
import SignUpFriend from '@/views/sign-up-friend'
import SignUpPhone from '@/views/sign-up-phone'
import Terms from '@/views/terms'
import Upgrade from '@/views/upgrade'
import Welcome from '@/views/welcome'
import vHash from '@/views/v-hash'
import Referrals from '@/views/referrals'
import VerifyEmail from '@/views/verify-email'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin',
      name: 'admin',
      component: () => import('@/views/admin.vue')
    },

    {
      path: '/admin/payables',
      name: 'payables',
      component: () => import('@/views/payables.vue')
    },
    
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },

    {
      path: '/v-hash',
      name: 'v-hash',
      component: vHash
    },

    {
      path: '/',
      redirect: { name: 'sign-in' }
    },

    {
      path: '/about-us',
      name: 'about-us',
      component: AboutUs
    },

    {
      path: '/pricetable',
      name: 'pricetable',
      component: PriceTable
    },

    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },

    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/account/:preset?',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/sign-in',
      name: 'sign-in',
      component: SignIn
    },

    { 
      path: '/sign-up',
      name: 'sign-up',
      component: SignUp
    },

    { // if biz id, then invited as customer
      path: '/sign-up/:bid/:email',
      name: 'sign-up-cus',
      component: SignUpCustomer
    },

    {
      path: '/i/:bid',
      name: 'sign-up-link',
      component: SignUpLink
    },

    {
      path: '/f/:uid',
      name: 'sign-up-friend',
      component: SignUpFriend
    },

    {
      path: '/r/:id?',
      name: 'sign-up-ref',
      component: SignUpRef
    },

    {
      path: '/phone-number/:id?',
      name: 'sign-up-phone',
      component: SignUpPhone
    },

    {
      path: '/password/reset',
      name: 'forgot-password',
      component: ForgotPassword
    },

    {
      path: '/m/:id',
      name: 'merchant',
      component: Merchant,
    },

    {
      path: '/merchant/:id',
      name: 'merchant',
      component: Merchant,
    },

    {
      path: '/merchants',
      name: 'merchants',
      component: Merchants,
    },

    {
      path: '/market/:username?',
      name: 'merchants-list',
      component: MerchantsList,
    },

    {
      path: '/referrals',
      name: 'referrals',
      component: Referrals,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/purse',
      name: 'purse',
      component: Purse,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/welcome/:modals?',
      name: 'welcome',
      component: Welcome,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/notifications/referral',
      name: 'ref-notifications',
      component: RefNotifications,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/notifications/personal',
      name: 'per-notifications',
      component: PerNotifications,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/notifications/business',
      name: 'biz-notifications',
      component: BizNotifications,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/profile/',
      name: 'profile',
      component: Profile,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/onboarding/profile/',
      name: 'new-profile',
      component: NewProfile,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/business-profile/:thanks?',
      name: 'business-profile',
      component: BusinessProfile,
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      }
    },

    {
      path: '/verify-email/:id',
      name: 'verify-email',
      component: VerifyEmail,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/qr-referral',
      name: 'qr-referral',
      component: QrReferral,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/help-center',
      name: 'help-center',
      component: HelpCenter,
    },

    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },

    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },

    {
      path: '/marketing',
      name: 'marketing',
      component: Marketing,
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      }
    },    

    {
      path: '/customers',
      name: 'customers',
      redirect: { name: 'acquired' },
      component: () => import( '@/views/customers/index' ),
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      },
      children: [
        {
          path: 'fans',
          name: 'fans',
          component: () => import( '@/views/customers/fans' ),
        },
        {
          path: 'prospects',
          name: 'prospects',
          component: () => import( '@/views/customers/prospects' ),
        },
        {
          path: 'acquired',
          name: 'acquired',
          component: () => import( '@/views/customers/acquired' ),
        }
      ]
    },

    {
      path: '/selling',
      name: 'selling',
      redirect: { name: 'services' },
      component: () => import( '@/views/selling/index' ),
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      },
      children: [
        {
          path: 'services',
          name: 'services',
          component: () => import( '@/views/selling/services' ),
        },
        {
          path: 'products',
          name: 'products',
          component: () => import( '@/views/selling/products' ),
        },
        {
          path: 'catalogs',
          name: 'catalogs',
          component: () => import( '@/views/selling/catalogs' ),
        }
      ]
    },
    

    {
      path: '/orders',
      name: 'orders',
      component: Orders,
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      }
    },

    {
      path: '/orders/weekly',
      name: 'orders-weekly',
      component: OrdersWeekly,
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      }
    },

    {
      path: '/dashboard/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        requiresMerchant: true
      }
    },

    {
      path: '/onboarding',
      name: 'onboarding',
      component: Onboarding,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/merchant-offer',
      name: 'merchant-offer',
      component: MerchantOffer,
    },

    {
      path: '/upgrade',
      name: 'upgrade',
      component: Upgrade,
      meta: {
        requiresAuth: true
      }
    }
  ],
  scrollBehavior(to, from, savedPosition){
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
